import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'antd';

import { updateTaxReceiptConfigurationOrganizationDetails } from '../../taxReceiptActions';
import { fetchCountries, fetchProvinces  } from 'Parts/geo/geoActions'

import TaxReceiptAdminConfigurationOrganizationDetailsForm from './TaxReceiptAdminConfigurationOrganizationDetailsForm';

const mapStateToProps = state => ({
  countries: state.geo.countries,
  provinces: state.geo.provinces,
  organization: state.organization.organization,
  configuration: state.TaxReceipt.taxReceiptConfiguration,
  isUpdateConfigurationInProgress: state.TaxReceipt.isUpdateConfigurationInProgress,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  updateTaxReceiptConfigurationOrganizationDetails,
  fetchCountries,
  fetchProvinces
}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  Form.create()
)(TaxReceiptAdminConfigurationOrganizationDetailsForm);
